
import { useSelector } from "react-redux";
const BellIcon = () => {
    const counts = useSelector((state) => state.count);
    return (
        <svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M8.93297 3.27228C4.49868 3.27228 2.57202 7.28752 2.57202 9.9418C2.57202 11.9256 2.85964 11.3418 1.76154 13.7618C0.420588 17.2104 5.81297 18.6199 8.93297 18.6199C12.052 18.6199 17.4444 17.2104 16.1044 13.7618C15.0063 11.3418 15.2939 11.9256 15.2939 9.9418C15.2939 7.28752 13.3663 3.27228 8.93297 3.27228Z" stroke="#828282" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.2428 21.2703C9.94852 22.716 7.92947 22.7331 6.6228 21.2703" stroke="#828282" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            {counts && <circle cx="13.6487" cy="4.96283" r="3.84369" fill="#E01515" stroke="white" />}
        </svg>
    )
}

export default BellIcon;